import { useTranslation } from 'react-i18next';
import logo from '../image/logo/barcelona cab logo.png';

const About = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white font-montserrat pt-24">
            {/* Hero Section */}
            <div className="relative bg-slate-900 py-32 md:py-48 overflow-hidden animate-fade-in">
                <div className="absolute inset-0 z-0">
                    <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-900/90 to-blue-900/20 opacity-90"></div>
                </div>
                <div className="relative mx-auto max-w-7xl px-6 lg:px-8 text-center z-10">
                    <div className="inline-flex items-center gap-3 px-5 py-2 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 text-white text-xs font-black uppercase tracking-[0.2em] shadow-2xl mb-8">
                        <span>The Company</span>
                    </div>
                    <h1 className="text-5xl md:text-8xl font-black tracking-tighter text-white leading-[0.9] drop-shadow-2xl">
                        {t('about.hero_title') || "About MY TAXI BCN"}
                    </h1>
                    <p className="mt-8 text-xl md:text-2xl leading-relaxed text-blue-100 max-w-3xl mx-auto font-medium drop-shadow-lg">
                        {t('about.hero_subtitle') || "Your trusted partner for reliable, comfortable, and efficient transportation in the heart of Barcelona."}
                    </p>
                </div>
            </div>

            {/* Mission Section */}
            <div className="mx-auto max-w-7xl px-6 lg:px-8 py-24 md:py-40">
                <div className="grid grid-cols-1 gap-y-20 gap-x-16 lg:grid-cols-2 lg:items-center">
                    <div>
                        <h2 className="text-3xl md:text-5xl font-black tracking-tighter text-slate-900 uppercase mb-8">
                            {t('about.mission_title') || "Our Mission"}
                        </h2>
                        <div className="space-y-6">
                            <p className="text-xl leading-relaxed text-slate-600 font-medium border-l-4 border-blue-600 pl-6 italic">
                                {t('about.mission_p1') || "At MY TAXI BCN, we believe that getting around should be the easiest part of your day."}
                            </p>
                            <p className="text-lg leading-relaxed text-slate-500 font-medium">
                                {t('about.mission_p2') || "We combine modern technology with traditional hospitality to ensure every ride is safe, punctual, and pleasant."}
                            </p>
                        </div>

                        <div className="mt-12 grid grid-cols-1 gap-x-12 gap-y-8 sm:grid-cols-2">
                            {[
                                { key: 'feature_drivers', title: "Professional Drivers" },
                                { key: 'feature_247', title: "24/7 Availability" },
                                { key: 'feature_group_size', title: "7 & 8 Seater Minivans" },
                                { key: 'feature_baby_seat', title: "Free Baby Seats" }
                            ].map((feature) => (
                                <div key={feature.key} className="flex items-center gap-x-4 p-4 rounded-2xl bg-slate-50 border border-slate-100 shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5">
                                    <div className="flex-none rounded-xl bg-blue-600 p-2 shadow-lg shadow-blue-200">
                                        <div className="h-2 w-2 rounded-full bg-white animate-pulse" />
                                    </div>
                                    <h3 className="text-sm font-black uppercase tracking-tight text-slate-900">{t(`about.${feature.key}`) || feature.title}</h3>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="relative group">
                        <div className="absolute -inset-4 bg-blue-600/5 rounded-[40px] blur-2xl group-hover:bg-blue-600/10 transition-all duration-500"></div>
                        <div className="relative aspect-[4/3] overflow-hidden rounded-[40px] bg-white shadow-2xl border border-slate-100 flex items-center justify-center p-12 transform group-hover:scale-[1.02] transition-all duration-500">
                            <img
                                src={logo}
                                alt="Barcelona Cab Logo"
                                className="w-full h-full object-contain drop-shadow-xl"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* SEO Block Section */}
            <div className="bg-slate-50 py-16 mb-24 border-y border-slate-200">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <p className="text-lg md:text-xl leading-relaxed text-slate-600 font-medium text-center max-w-5xl mx-auto">
                        {t('about.seo_p')}
                    </p>
                </div>
            </div>

            {/* Stats Section */}
            <div className="bg-slate-900 py-32 rounded-[64px] mx-4 mb-24 shadow-2xl relative overflow-hidden">
                <div className="absolute top-0 right-0 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl -mr-48 -mt-48"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl -ml-48 -mb-48"></div>

                <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
                    <dl className="grid grid-cols-1 gap-x-12 gap-y-16 text-center lg:grid-cols-3">
                        {[
                            { key: 'stat_trips', label: "Trips Completed", value: "10k+" },
                            { key: 'stat_customers', label: "Happy Customers", value: "98%" },
                            { key: 'stat_drivers', label: "Professional Drivers", value: "50+" }
                        ].map((stat) => (
                            <div key={stat.key} className="mx-auto flex max-w-xs flex-col gap-y-6 py-8 px-12 rounded-[32px] bg-white/5 border border-white/10 backdrop-blur-sm shadow-xl">
                                <dt className="text-xs font-black uppercase tracking-[0.2em] text-blue-400">{t(`about.${stat.key}`) || stat.label}</dt>
                                <dd className="text-5xl md:text-7xl font-black tracking-tighter text-white drop-shadow-lg">{stat.value}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>
        </div>
    );
};

export default About;
